export type BrandState = {
  filterData: { name: string; id: string | number; type: string; date?: number }[];
  orderType: 'first_word_desc' | 'first_word_asc' | 'new_desc' | 'update_desc' | 'update_asc';
  hasOtherCity: boolean;
};

export default {
  namespace: 'brand',
  state: {
    filterData: [],
    orderType: 'first_word_asc',
    hasOtherCity: false,
  },
  reducers: {
    setOrderType(state: BrandState, { payload }: { payload: BrandState['orderType'] }) {
      return { ...state, orderType: payload };
    },
    setFilterData(state: BrandState, { payload }) {
      return { ...state, filterData: payload };
    },
    setHasOtherCity(state: BrandState, { payload }) {
      return { ...state, hasOtherCity: payload };
    },
  },
};
